<template>
  <div>
    <div
      class="note_analyst"
      v-for="(group, index) in groupedPosts"
      :key="index"
    >
      <div class="dateAnalyst" v-html="group.dateGroup"></div>
      <div class="row mt-4 row-cols-2">
        <div class="col" v-for="(post, index2) in group.posts" :key="post.Id">
          <journalist-card :post="post" :idx="index2" />
        </div>
      </div>
    </div>

    <div class="title-section analisisSect" @click="getPosts" v-show="enabled">
      <h3 class="heading-title-sect text-center">
        <span>MÁS ANÁLISIS</span>
      </h3>
    </div>
  </div>
</template>

<script>
import JournalistCard from "./../journalist-card/JournalistCard.vue";
import axios from "axios";
import epica from "../../../features/epica";

export default {
  components: { JournalistCard },
  props: {
    journalistId: Number,
    journalistName: String,
    initOffset: Number,
    idx: Number,
    total: Number,
  },
  created: function () {
    this.tfNews = {};
    this.offset = 0;
  },
  mounted: function () {
    this.postIdx = this.idx;
    this.take = this.initOffset + 15;
  },
  updated: function () {
    epica();
    document.dispatchEvent(lrLoad);
  },
  methods: {
    ctrlFirstPage: function () {
      if (!this.firstUse && this.groupedPosts.length > 0) {
        this.$emit("hide-first-page");
        this.take = 15;
        this.firstUse = true;
      }
    },
    getPosts: function () {
      this.loading = true;
      var _self = this;
      axios
        .get("/api/pager/journalist", {
          params: {
            id: this.journalistId,
            name: this.journalistName,
            take: this.take,
            offset: this.offset,
          },
        })
        .then(function (d) {
          _self.loading = false;
          var lastGroupIdx = _self.groupedPosts.length - 1;
          if (
            _self.groupedPosts.length > 0 &&
            _self.groupedPosts[lastGroupIdx].dateGroup == d.data[0].dateGroup
          ) {
            _self.groupedPosts[lastGroupIdx].posts = _self.groupedPosts[
              lastGroupIdx
            ].posts.concat(d.data[0].posts);
            d.data.splice(0, 1);
          }
          _self.groupedPosts = _self.groupedPosts.concat(d.data);
          _self.offset += _self.take;
          _self.ctrlFirstPage();
        });
    },
  },
  computed: {
    enabled: function () {
      return (
        this.initOffset < this.total &&
        this.offset < this.total &&
        !this.loading
      );
    },
  },
  data: function () {
    return {
      groupedPosts: [],
      loading: false,
      firstUse: false,
    };
  },
};
</script>
